import {connect, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput, CFormSelect,
    CInputGroup,
    CInputGroupText, CModal, CModalBody,
    CModalHeader, CModalTitle,
    CRow
} from "@coreui/react";
import numeral from "numeral";
import {AgGridReact} from "ag-grid-react";
import * as api from "../../../api/api";
import {Loading} from "../../../components/common";
//import StoreListWhere from "../where/StoreListWhere";
import BrandListWhere from "../where/BrandListWhere";
import StoreDetail from "../store/StoreDetail";
import {currencyFormatter, onlyNumberFormatter} from "../../../config/formatter";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const ProductExpire = (props) => {
    const {user} = useSelector((props) => props.account);

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]);
    const [searchForm, setSearchForm] = useState({
        cmpCd: "",
        brandCd: "",
        storeCd: "",
        restProductCd: "",
        productNm: "",
        barcode: ""
    });
    const [brandData, setBrandData] = useState([]);

    const [productExpireData, setProductExpireData] = useState([]);

    const [selectProduct, setSelectProduct] = useState({});
    const [selectNationCd, setSelectNationCd] = useState("US");


    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "cmpCd", headerName: "회원사코드",  width: 130, hide:true},
        {field: "brandCd", headerName: "브랜드코드",  width: 130, hide:true},
        {field: "brandNm", headerName: "휴게소명",  width: 130},
        {field: "productCd", headerName: "상품코드", hide:true, width: 130},
        {field: "restProductCd", headerName: "상품코드", width: 130},
        {field: "productNm", headerName: "상품명"},
        {field: "brandPrice", headerName: "판매가",  minWidth: 100, valueFormatter: currencyFormatter},
        {field: "expiredFrom", editable: true,  headerName: "판매-시작시간\n(0000)", width: 130, }, //
        {field: "expiredTo",editable: true,  headerName: "판매-종료시간\n(2359)", width: 130},
        {field: "soldoutYn", headerName: "제조상품 숨김처리\n(Y/N)", width: 130, editable: true},
        //{field: "soldoutYn", headerName: "제조상품 숨김 처리", width: 130, cellRendererFramework: checkBoxFormatter , cellRendererParams : fncCellRendererParams},
        {field: "updTime", headerName: "등록일자", width: 130, hide:true}
    ]);

    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
        //console.log("변경 시 brandCd : ", searchForm.brandCd);
    };


    const save = async () => {
        //console.log("저장");

        const {cmpCd, brandCd} = searchForm;
        gridRef.current.api.stopEditing();

        // 딜레이를 주자updateRows
        setTimeout(() => {
            console.log(">>> 저장 시 쌓인 updateRows :: ", updateRows);
            setLoading(true);

            if(updateRows.length === 0){
                alert("변경된 데이터가 없습니다.");
                return;
            }

            api.putProductExpire(updateRows).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    alert("처리되었습니다.");
                    search();
                }
            })
                .catch((e) => {
                    console.log("### error :: ", e.message);
                })
                .finally(() => {
                    setLoading(false);
                })
        }, 200);

    }


    const search = () => {
        setError({
            visible: false,
            message: ""
        });

        const {cmpCd, brandCd, storeCd} = searchForm;
        console.log("searchForm::", searchForm);

        if (brandCd.length === 0) {
            setError({
                visible: true,
                message: "조회시 휴게소는 반드시 선택하셔야 합니다."
            });
            alert("조회 시 휴게소를 반드시 선택하세요.");
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            restProductCd: searchForm.restProductCd,
            productNm: searchForm.productNm,
            barcode: searchForm.barcode,
            isUse : "Y"
        };

        console.log("params:: ", params);

        setLoading(true);

        api.getProductExpire(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log("result : ", responseBody);
                [responseBody.brandCd] = brandCd;

                setLoading(false);
                setProductExpireData(responseBody);
            }
        });
    };

    function fncCellRendererParams(rowIndex, rowData){

        onEventChange: (rowIndex, rowData) => {
            console.log("rowIndex:: ", rowIndex);
            //console.log("rowNode:: " , rowNode);
            ///console.log("rowIndex:: " , rowIndex);

            const data = [];
            const {api} = gridRef.current;
            api.forEachNode(function (rowNode, index) {
                data.push(rowNode.data);
            });

            setProductExpireData(
                data.map((item, idx) => (idx === rowIndex ? rowData : item))
            )
        }

    }

    const handleChange = (e) => {

        console.log("handleChange");


        const { api } = gridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        selectRows[0].soldoutYn = e.target.value;

        console.log("숨김처리 변경 후  selectRows: ", selectRows[0]);



        getUpdateRows(selectRows);

    }

    function checkBoxFormatter(params) {
        const data = params.data;
        return (
            <CFormSelect id={data.soldoutYn + data.soldoutYn}
                         className={"pt-0 pb-0"}
                         style={{height: 30}}
                         value={data.soldoutYn}
                         onChange={onCellEditingStopped} //
                         /*onChange={(e) => {
                             setProductExpireData((state) => ({
                                 ...state,
                                 soldoutYn: e.target.value
                             }));
                         }}*/
            >
                <option style={{height: 30}} value="N">N</option>
                <option style={{height: 30}} value="Y">Y</option>
            </CFormSelect>
        )
    }




    const onCellEditingStopped = (e) => {
        console.log("onCellEditingStopped ");
        const { api } = gridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        if(e.colDef.field === "soldoutYn"){
            console.log("숨김처리 ");
        }
        else{
            if(selectRows[0].expiredFrom === null || selectRows[0].expiredTo === null){
                return;
            }
        }

        //console.log("onCellEditingStopped에서 selectRows: ", selectRows);

        getUpdateRows(selectRows);
    }

    let updateRows = [];

    const getUpdateRows = (data) => {
        const {cmpCd, brandCd, storeCd} = props.selected;

        const row = {
            cmpCd: data[0].cmpCd,
            brandCd: data[0].brandCd,
            productCd: data[0].productCd,
            expiredFrom: data[0].expiredFrom,
            expiredTo: data[0].expiredTo,
            soldoutYn: data[0].soldoutYn,
            instUser : user.userId,
            updUser: user.userId,
            useYn: "Y"
        }

        updateRows.push(row);

        console.log(">>> 현재 updateRows :: ", updateRows);
    }





    const onRowSelected = useCallback((event) => {
        console.log("event.node.data:: ", event.node.data);
        //getProductExpire(event.node.data);

    }, []);


    /*화면 영역 Grid Start*/
    return (
        <>
            <div style={containerStyle}>
                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                    <h5>휴게소별 판매시간 및 품절 관리</h5>
                    <div>
                        <CButton size={"sm"} style={{marginRight: 10}} color="primary" onClick={save}>저장</CButton>
                        <CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
                    </div>
                </div>

                <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                    {/*<BrandListWhere account={props.account} selected={searchForm}  onSelect={(c, v) => handleSelect(c, v)}/>*/}
                    <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                                          onSelect={(c, v) => handleSelect(c, v)}/>

                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{ width: 80 }}>상품코드</CInputGroupText>
                            <CFormInput id="productCd"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                restProductCd: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{ width: 80 }}>상품명</CInputGroupText>
                            <CFormInput id="productNm"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                productNm: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                    <CCol xs={12}>
                        <CInputGroup size={"sm"} className={"mb-1"}>
                            <CInputGroupText style={{ width: 80 }}>바코드</CInputGroupText>
                            <CFormInput id="barcode"
                                        style={{height: 35}}
                                        onChange={(e) => {
                                            setSearchForm((state) => ({
                                                ...state,
                                                barcode: e.target.value
                                            }));
                                        }}/>
                        </CInputGroup>
                    </CCol>
                </CForm>

                <div>
                    <CRow>
                        {/*<CCol xs={3}>
                     <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                         휴게소 목록
                     </div>
                     <div className="ag-theme-alpine" style={{width: "100%", height: 550, marginTop: 10}}>
                         <AgGridReact
                             rowSelection={"single"}
                             headerHeight={30}
                             rowHeight={30}
                             rowData={brandData}
                             animateRows={true}
                             localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                             onRowClicked={onRowSelected}
                             defaultColDef={defaultColDef}
                             columnDefs={columnDefs}>
                         </AgGridReact>
                     </div>
                   </CCol>
                    */}
                        <CCol >
                            <div style={{ borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                                휴게소별 판매시간 설정(시작시간(0000) ~ 종료시간(2359) -->(00시00분) ~ (23시59분))
                            </div>
                            <div className="ag-theme-alpine" style={{width: "100%", height: 550, marginTop: 10}}>
                                <AgGridReact
                                    ref={gridRef}
                                    rowSelection={"single"}
                                    headerHeight={30}
                                    rowHeight={30}
                                    rowData={productExpireData}
                                    animateRows={true}
                                    localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                                    /*onRowClicked={onRowSelected}*/
                                    onCellEditingStopped={onCellEditingStopped}


                                    defaultColDef={defaultColDef}
                                    columnDefs={columnDefs}>
                                </AgGridReact>
                            </div>
                        </CCol>

                    </CRow>
                </div>



            </div>
        </>
    ) //End return 화면영역

}

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductExpire);